import React, { useEffect, useState } from "react";
import { getPartners, getPartnerPage } from "../lib/api";
import { Page, PageHeader, Section, CardGrid } from "../components/ui";
import IconByName from "../components/IconByName";
import "../styles/PartnerPage.css";

const FALLBACK_TITLE = "PARTNER";
const FALLBACK_SUBTITLE =
  "Unsere Schule kooperiert mit Partnern, die Lernen erweitern: durch Technik, Kultur, Kreativität und konkrete Projekte für Kinder.";

export default function PartnerPage() {
  const [partners, setPartners] = useState(null);
  const [page, setPage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    getPartners()
      .then((res) => !cancelled && setPartners(res))
      .catch((err) => !cancelled && setError(err));

    // Eigener Catch: fehlt die Single Type noch, greifen die Fallback-Texte,
    // statt die ganze Seite mit einem Fehler zu blockieren.
    getPartnerPage()
      .then((res) => !cancelled && setPage(res))
      .catch(console.error);

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Page error={error}>
      <PageHeader
        parent={{ label: "Über Uns", to: "/profil" }}
        current="Partner"
        title={page?.heroTitle || FALLBACK_TITLE}
        subtitle={page?.heroSubtitle || FALLBACK_SUBTITLE}
      />

      <Section>
        {!partners ? <p>Lädt…</p> : null}

        <CardGrid cols={4}>
          {(partners || []).map((partner) => (
            <PartnerCard key={partner.id} partner={partner} />
          ))}
        </CardGrid>
      </Section>
    </Page>
  );
}

function PartnerCard({ partner }) {
  return (
    <article className="partner-card">
      {partner.website ? (
        <a
          className="partner-card__link"
          href={partner.website}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Website von ${partner.name} öffnen`}
        >
          <IconByName name="globe" size={16} />
        </a>
      ) : null}

      <div className="partner-card__logoWrap">
        {partner.logo ? (
          <img
            className="partner-card__logo"
            src={partner.logo.url}
            alt={partner.logo.alt || `${partner.name} Logo`}
            loading="lazy"
          />
        ) : (
          <span className="partner-card__logoFallback">{partner.name.slice(0, 2)}</span>
        )}
      </div>

      <div className="partner-card__top">
        {partner.label ? <p className="partner-card__label">{partner.label}</p> : null}
        <h3 lang="de">{partner.name}</h3>
      </div>

      {partner.intro ? <p className="partner-card__intro">{partner.intro}</p> : null}

      {partner.points?.length ? (
        <ul className="partner-card__points">
          {partner.points.map((point) => (
            <li key={point}>
              <span aria-hidden="true" />
              {point}
            </li>
          ))}
        </ul>
      ) : null}
    </article>
  );
}